import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import WhatWeDo from "@/pages/WhatWeDo";
import OurImpact from "@/pages/OurImpact";
import ContactUs from "@/pages/ContactUs";
import Blogs from "@/pages/Blogs";
import FAQs from "@/pages/FAQs";
import Login from "@/pages/Login";
import CMS from "@/pages/CMS";

function App() {
  return (
    <div className="App bg-[#FAFAFA] text-[#0A0A0A]">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/our-impact" element={<OurImpact />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cms" element={<CMS />} />
          </Routes>
        </main>
        <Footer />
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
